import { render } from "./Header.vue?vue&type=template&id=12e2a871&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=12e2a871&lang=css"
import "./Header.vue?vue&type=style&index=1&id=12e2a871&scoped=true&lang=less"

import exportComponent from "F:\\luyou\\luyou_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e2a871"]])

export default __exports__